/**
 * Homy Domain & Platform Role Taxonomy
 */

export type UserRole =
  | "SUPER_ADMIN"
  | "PLATFORM_ADMIN"
  | "ORG_ADMIN"
  | "ADMIN"
  | "MANAGER"
  | "OWNER"
  | "TENANT"
  | "VENDOR"
  | "USER"
  | "VIEWER"
  | "MAINTENANCE_COORDINATOR"
  | "COLLABORATOR"
  | "RESTRICTED";

export const USER_ROLES: readonly UserRole[] = [
  "SUPER_ADMIN",
  "PLATFORM_ADMIN",
  "ORG_ADMIN",
  "ADMIN",
  "MANAGER",
  "OWNER",
  "TENANT",
  "VENDOR",
  "USER",
  "VIEWER",
  "MAINTENANCE_COORDINATOR",
  "COLLABORATOR",
  "RESTRICTED",
] as const;

export type PlatformRole =
  | "PLATFORM_SUPERADMIN"
  | "PLATFORM_ADMIN"
  | "PLATFORM_OPERATOR"
  | "PLATFORM_AUDITOR";

export const PLATFORM_ROLES: readonly PlatformRole[] = [
  "PLATFORM_SUPERADMIN",
  "PLATFORM_ADMIN",
  "PLATFORM_OPERATOR",
  "PLATFORM_AUDITOR",
] as const;

export const OPERATIONS_ROLES: readonly UserRole[] = [
  "SUPER_ADMIN",
  "PLATFORM_ADMIN",
  "ORG_ADMIN",
  "ADMIN",
  "MANAGER",
  "OWNER",
  "MAINTENANCE_COORDINATOR",
  "VIEWER",
  "COLLABORATOR",
] as const;

export const RESIDENT_ROLES: readonly UserRole[] = [
  "TENANT",
  "USER",
] as const;

export const CONTRACTOR_ROLES: readonly UserRole[] = [
  "VENDOR",
] as const;

export const ALL_ROLES: readonly UserRole[] = [
  "SUPER_ADMIN",
  "PLATFORM_ADMIN",
  "ORG_ADMIN",
  "ADMIN",
  "MANAGER",
  "OWNER",
  "TENANT",
  "VENDOR",
  "USER",
  "VIEWER",
  "MAINTENANCE_COORDINATOR",
  "COLLABORATOR",
  "RESTRICTED",
] as const;
